<div class="title p-2">
    <div class="row">
        <div class="col d-flex justify-content-start align-items-center">
            <h1 class="mx-1">
                <span>Info solicitare {{cerere?.indoc_number ? cerere?.indoc_number : 'N/A' }} / {{ cerere?.created_at | date:
                    'dd.MM.yyyy' }}</span>
                <span class="text-secondary m-2">#{{ cerere?.id }}</span>
                <button type="button" class="btn btn-small btn-primary" (click)="getRequestInfo()">
                    <i class="fa-solid fa-arrows-rotate"></i>
                    <span class="ms-2">Reîncarcă informații</span>
                </button>
            </h1>
        </div>
        <div class="col d-flex justify-content-end">
            <button type="button" class="action-btn" (click)="closeDialog()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
</div>

<div class="row p-3 responsive-column">
    <div class="col-8 responsive-box-info">
        <div class="g-0">
            <div class="row">
                <div class="col ">
                    <div class="box-wrapper box-mesagerie">
                        <div class="box-content-header">
                            <div class="row p-1">
                                <div class="col">
                                    <mat-card-title>
                                        <i class="fa-solid fa-book"></i>
                                        <span>Conținut solicitare</span>
                                    </mat-card-title>
                                </div>
                            </div>
                        </div>
                        <div class="box-content-body">
                            <div class="col">
                                <div class="row py-1 mx-1 bg">
                                    <div class="col">
                                        <div class="fw-bold">Nume</div>
                                    </div>
                                    <div class="col">
                                        <div class="fw-bold">Prenume</div>
                                    </div>
                                    <div class="col">
                                        <div class="fw-bold">Telefon</div>
                                    </div>
                                </div>
                                <div class="row py-1 mx-1">
                                    <div class="col">
                                        <div>{{cerereCetatean?.nume}}</div>
                                    </div>
                                    <div class="col">
                                        <div>{{cerereCetatean?.prenume}}</div>
                                    </div>
                                    <div class="col">
                                        <div>
                                            <span>{{contCetatean?.international_number || cerereCetatean?.international_number || cerereCetatean?.telefon || 'n/a'}}</span>
                                            <span *ngIf="cerere?.type_slug == 'recuperare_cod_pin'"
                                                (click)="updatePhoneNumber()">
                                                <i class="fa-solid fa-pencil orange-text px-1 pointer"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="row py-1 mx-1 bg">
                                    <div class="col">
                                        <div class="fw-bold">Email</div>
                                    </div>
                                    <div class="col">
                                        <div class="fw-bold">Număr cerere</div>
                                    </div>
                                    <div class="col">
                                        <div class="fw-bold">Observații</div>
                                    </div>
                                </div>
                                <div class="row py-1 mx-1">
                                    <div class="col">
                                        <div>{{contCetatean?.email || cerereCetatean?.email || 'n/a'}}</div>
                                    </div>
                                    <div class="col">
                                        <div>{{cerereCetatean?.cerere_id}}</div>
                                    </div>
                                    <div class="col">
                                        <div>{{cerereCetatean?.observations || 'n/a'}}</div>
                                    </div>
                                </div>

                                <ng-container *ngIf="
                                    cerere?.type_slug === 'suport_online_login' ||
                                    cerere?.type_slug === 'suport_online_account' ||
                                    cerere?.type_slug === 'validare_new_beneficiar' ||
                                    cerere?.type_slug === 'validare_prelungire_beneficiar' ||
                                    cerere?.type_slug === 'recuperare_cod_pin'
                                ">
                                    <div class="row py-1 mx-1 bg">
                                        <div class="col-4">
                                            <div class="fw-bold">CNP/CUI</div>
                                        </div>
                                    </div>
                                    <div class="row py-1 mx-1">
                                        <div class="col-4">
                                            <div>{{contCetatean?.cnp || cerereCetatean?.cnp || 'n/a'}}</div>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="contBeneficiar && 
                                (cerere?.type_slug === 'validare_new_beneficiar' || 
                                cerere?.type_slug === 'validare_prelungire_beneficiar')">
                                    <div *ngIf="contBeneficiar.beneficiar_type == '1'">
                                        <div class="row py-1 mx-1 bg">
                                            <div class="col">
                                                <div class="fw-bold">Nume beneficiar</div>
                                            </div>
                                            <div class="col">
                                                <div class="fw-bold">Prenume beneficiar</div>
                                            </div>
                                            <div class="col">
                                                <div class="fw-bold">CNP beneficiar</div>
                                            </div>
                                        </div>
                                        <div class="row py-1 mx-1">
                                            <div class="col">
                                                <div>{{contBeneficiar.nume}}</div>
                                            </div>
                                            <div class="col">
                                                <div>{{contBeneficiar.prenume}}</div>
                                            </div>
                                            <div class="col">
                                                <div>{{contBeneficiar.cnp_cui}}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div *ngIf="contBeneficiar.beneficiar_type == '2'">
                                        <div class="row py-1 mx-1 bg">
                                            <div class="col">
                                                <div class="fw-bold">Denumire companie beneficiar</div>
                                            </div>
                                            <div class="col">
                                                <div class="fw-bold">CUI/CIF beneficiar</div>
                                            </div>
                                            <div class="col">
                                                <div class="fw-bold">Registrul comerțului beneficiar</div>
                                            </div>
                                        </div>
                                        <div class="row py-1 mx-1">
                                            <div class="col">
                                                <div>{{contBeneficiar.denumire}}</div>
                                            </div>
                                            <div class="col">
                                                <div>{{contBeneficiar.cnp_cui}}</div>
                                            </div>
                                            <div class="col">
                                                <div>{{contBeneficiar.reg_com || 'n/a'}}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row py-1 mx-1 bg">
                                        <div class="col">
                                            <div class="fw-bold">Status cont beneficiar</div>
                                        </div>
                                        <div class="col">
                                            <div class="fw-bold">Cont beneficiar validat</div>
                                        </div>
                                        <div class="col">
                                            <div class="fw-bold">Expirare cont beneficiar</div>
                                        </div>
                                    </div>
                                    <div class="row py-1 mx-1">
                                        <div class="col">
                                            <div [class.active]="contBeneficiar.active" [class.inactive]="!contBeneficiar.active">
                                                {{contBeneficiar.active ? 'Activ' : 'Inactiv'}}
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div>{{contBeneficiar.validated_date ? 'Da' : 'Nu'}}</div>
                                        </div>
                                        <div class="col">
                                            <div>{{contBeneficiar.expiry_date | date: 'dd.MM.yyyy, hh:mm'}}</div>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="
                                    cerere?.type_slug === 'validare_cont_nou' ||
                                    cerere?.type_slug === 'validare_cont_pre_inrolat'
                                ">
                                    <div class="row py-1 mx-1 bg">
                                        <div class="col">
                                            <div class="fw-bold">CNP/CUI</div>
                                        </div>
                                        <div class="col">
                                            <div class="fw-bold">Status cont</div>
                                        </div>
                                        <div class="col">
                                            <div class="fw-bold">Mobile active</div>
                                        </div>
                                    </div>
                                    <div class="row py-1 mx-1">
                                        <div class="col">
                                            <div>{{contCetatean.cnp}}</div>
                                        </div>
                                        <div class="col">
                                            <div [class.active]="contCetatean.active" [class.inactive]="!contCetatean.active">
                                                {{contCetatean.active ? 'Activ' : 'Inactiv'}}
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div>{{contCetatean.phone_verification ? 'Da' : 'Nu'}}</div>
                                        </div>
                                    </div>
                                    <div class="row py-1 mx-1 bg">
                                        <div class="col">
                                            <div class="fw-bold">SMS Requests</div>
                                        </div>
                                    </div>
                                    <div class="row py-1 mx-1">
                                        <div class="col">
                                            <div *ngFor="let verification of verificareCont">
                                                <div class="row">
                                                    <div class="col-auto">
                                                        <div>#{{ verification.id_ticket }}</div>
                                                    </div>
                                                    <div class="col-auto">
                                                        <div>{{ verification.created_at | date }}</div>
                                                    </div>
                                                    <div class="col-auto">
                                                        <div>{{ verification.status }}</div>
                                                    </div>
                                                    <div class="col-auto">
                                                        <div>{{ verification.international_number }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="g-0" *ngIf="documenteCetatean.length > 0">
            <div class="col">
                <div class="box-wrapper box-documents">
                    <div class="box-content-header">
                        <div class="row p-1">
                            <div class="col">
                                <mat-card-title>
                                    <i class="fa-solid fa-folder-tree"></i>
                                    <span>Documente</span>
                                </mat-card-title>
                            </div>
                        </div>
                    </div>

                    <div class="box-content-body">
                        <div *ngFor="let document of documenteCetatean; let i = index">
                            <div class="row align-items-center pe-2">
                                <div class="col-auto">
                                    <img src="assets/icons/doc-icon.svg" alt="Document">
                                </div>
                                <div class="col">
                                    <div class="cerere-title">Cerere</div>
                                    <p>Denumire document: {{ document.old_name }}</p>
                                </div>
                                <div class="col-auto ms-auto">
                                    <button type="button" class="btn btn-light open-btn" (click)="downloadDocument(document)">
                                        <img src="/assets/icons/view.svg" alt="VIZUALIZAȚI" />
                                        <span class="view-btn-text">VIZUALIZAȚI</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="g-0">
            <div class="col">
                <div class="box-wrapper box-mesagerie">
                    <div class="box-content-header">
                        <div class="row p-1">
                            <div class="col">
                                <mat-card-title>
                                    <i class="fa-brands fa-rocketchat"></i>
                                    <span>Mesagerie</span>
                                </mat-card-title>
                            </div>
                            <div class="col d-flex justify-content-end">
                                <div>
                                    <mat-button-toggle-group name="fontStyle" aria-label="Font Style" (change)="onMessagingChange($event)" value="internalMsg">
                                        <mat-button-toggle value="toCetatean">Către Cetățean</mat-button-toggle>
                                        <mat-button-toggle value="internalMsg">Mesaj Intern</mat-button-toggle>
                                        <mat-button-toggle value="nota">Notă</mat-button-toggle>
                                    </mat-button-toggle-group>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="box-content-body">
                        <div class="row py-2" *ngIf="selectedMessagingToggle !== 'toCetatean'">
                            <div class="col">
                                <div class="fw-bold p-1">Adăugați un nou mesaj</div>
                            </div>
                        </div>
                        <div class="row py-2" *ngIf="selectedMessagingToggle == 'toCetatean'">
                            <div class="col">
                                <div class="fw-bold p-1">Transmiteți către cetatean un mesaj</div>
                            </div>
                        </div>

                        <form [formGroup]="sendMessageCetateanForm" (ngSubmit)="submitMessage('cetatean')" *ngIf="selectedMessagingToggle == 'toCetatean'">
                            <div class="row p-1">
                                <div class="col">
                                    <angular-editor formControlName="message" [config]="editorConfig"></angular-editor>
                                </div>
                            </div>

                            <div class="solicitare-card__upload mx-2 mt-3">
                                <div class="solicitare-card__upload-header">
                                    <p class="upload-text">Fotografii/Documente</p>
                                    <button class="upload-btn" (click)="fileInputCetatean.click()" type="button">
                                        <mat-icon class="upload-icon">cloud_upload</mat-icon>
                                        ÎNCARCĂ
                                    </button>
                                </div>
                                <div class="solicitare-card__upload-files" *ngIf="sendMessageCetateanForm.value.files.length > 0 && !uploading.file">
                                    <div class="solicitare-card__upload-file" *ngFor="let uploadedFile of sendMessageCetateanForm.value.files; let i = index">
                                        <span class="solicitare-card__upload-file-name">
                                            {{ (uploadedFile.original_name.length > 30) ? (uploadedFile.original_name | slice: 0:30) + '..' : (uploadedFile.original_name)
                                            }}
                                        </span>
                                        <div>
                                            <button class="solicitare-card__upload-file-delete" type="button" matTooltip="Șterge fișierul încărcat" (click)="removeFileCetatean(i)">
                                                <img class="btn-img" src="../../../assets/icons/delete.svg" alt="" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px" *ngIf="uploading.file"></mat-spinner>

                                <input type="file" accept="image/png, image/jpeg, image/gif, image/jpg, application/pdf" id="upload-file-input-0" #fileInputCetatean
                                    name="fileInputCetatean" (change)="addFileCetatean($event, 'file')" multiple style="display: none">
                            </div>


                            <div class="row my-3">
                                <div class="col d-flex align-items-center">
                                    <mat-checkbox style="margin-right: 30px" formControlName="notify" color="primary">Notificare răspuns
                                    </mat-checkbox>
                                    <form [formGroup]="notifyAnswer" style="width: 30%">
                                        <ng-container *ngIf="sendMessageCetateanForm.get('notify')?.value">
                                            <mat-form-field class="mt-3">
                                                <mat-label>Număr zile</mat-label>
                                                <mat-select formControlName="notify_date_expire">
                                                    <mat-option *ngFor="let response of responseTimes" [value]="response.value">
                                                        {{ response.key }}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error *ngIf="
                                                    notifyAnswer.get('notify_date_expire').touched &&
                                                    notifyAnswer
                                                        .get('notify_date_expire')
                                                        .hasError('required')
                                                    ">
                                                    Câmp obligatoriu
                                                </mat-error>
                                            </mat-form-field>
                                        </ng-container>
                                    </form>
                                </div>
                            </div>


                            <div class="row">
                                <div class="col d-flex justify-content-between">
                                    <div class="p-1">
                                        <button class="btn btn-light upload-btn" type="button" (click)="openSabloane()">
                                            <span class="upload__text">Șabloane</span>
                                        </button>
                                    </div>

                                    <div class="p-1">
                                        <button [disabled]="!sendMessageCetateanForm.valid" class="btn btn-light upload-btn" type="submit">
                                            <span class="upload__text">TRIMITE</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <form [formGroup]="sendMessageInternForm" (ngSubmit)="submitMessage('intern')" *ngIf="selectedMessagingToggle == 'internalMsg'">
                            <div class="row p-1">
                                <div class="col">
                                    <angular-editor formControlName="message" [config]="editorConfig"></angular-editor>
                                </div>
                            </div>

                            <div class="row p-1">
                                <mat-form-field class="w-100">
                                    <mat-label>Adaugă coleg</mat-label>
                                    <mat-chip-grid #chipGrid aria-label="Selectare colegi">
                                        <mat-chip-row *ngFor="let coleague of coleagues" (removed)="removeColeague(coleague)">
                                            {{coleague.name}}
                                            <button matChipRemove [attr.aria-label]="'remove ' + coleague.name">
                                                <mat-icon>cancel</mat-icon>
                                            </button>
                                        </mat-chip-row>
                                    </mat-chip-grid>
                                    <input placeholder="Coleg nou..." #coleagueInput [formControl]="coleaguesCtrl" [matChipInputFor]="chipGrid" [matAutocomplete]="auto"
                                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addColeague($event)"
                                    />
                                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedColeagues($event)">
                                        <mat-option *ngFor="let coleague of filteredColeagues | async" [value]="coleague">
                                            {{coleague.name}}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>

                            <div class="solicitare-card__upload mx-2">
                                <div class="solicitare-card__upload-header">
                                    <p class="upload-text">Fotografii/Documente</p>
                                    <button class="upload-btn" (click)="fileInputIntern.click()" type="button">
                                        <mat-icon class="upload-icon">cloud_upload</mat-icon>
                                        ÎNCARCĂ
                                    </button>
                                </div>
                                <div class="solicitare-card__upload-files" *ngIf="sendMessageInternForm.value.files.length > 0 && !uploading.file">
                                    <div class="solicitare-card__upload-file" *ngFor="let uploadedFile of sendMessageInternForm.value.files; let i = index">
                                        <span class="solicitare-card__upload-file-name">
                                            {{ (uploadedFile.original_name.length > 30) ? (uploadedFile.original_name | slice: 0:30) + '..' : (uploadedFile.original_name)
                                            }}
                                        </span>
                                        <div>
                                            <button class="solicitare-card__upload-file-delete" type="button" matTooltip="Șterge fișierul încărcat" (click)="removeFileIntern(i)">
                                                <img class="btn-img" src="../../../assets/icons/delete.svg" alt="" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px" *ngIf="uploading.file"></mat-spinner>

                                <input type="file" accept="image/png, image/jpeg, image/gif, image/jpg, application/pdf" id="upload-file-input-0" #fileInputIntern
                                    name="fileInputIntern" (change)="addFileIntern($event, 'file')" multiple style="display: none">
                            </div>

                            <div class="col d-flex justify-content-end">
                                <button [disabled]="!sendMessageInternForm.valid" class="btn btn-light upload-btn m-3" type="submit">
                                    <span class="upload__text">TRIMITE</span>
                                </button>
                            </div>

                        </form>

                        <form [formGroup]="sendMessageNotitaForm" (ngSubmit)="submitMessage('nota')" *ngIf="selectedMessagingToggle == 'nota'">
                            <div class="row p-1">
                                <div class="col">
                                    <angular-editor formControlName="message" [config]="editorConfig"></angular-editor>
                                </div>
                            </div>

                            <div class="solicitare-card__upload mx-2 mt-3">
                                <div class="solicitare-card__upload-header">
                                    <p class="upload-text">Fotografii/Documente</p>
                                    <button class="upload-btn" (click)="fileInputNotita.click()" type="button">
                                        <mat-icon class="upload-icon">cloud_upload</mat-icon>
                                        ÎNCARCĂ

                                    </button>
                                </div>
                                <div class="solicitare-card__upload-files" *ngIf="sendMessageNotitaForm.value.files.length > 0 && !uploading.file">
                                    <div class="solicitare-card__upload-file" *ngFor="let uploadedFile of sendMessageNotitaForm.value.files; let i = index">
                                        <span class="solicitare-card__upload-file-name">
                                            {{ (uploadedFile.original_name.length > 30) ? (uploadedFile.original_name | slice: 0:30) + '..' : (uploadedFile.original_name)
                                            }}
                                        </span>
                                        <div>
                                            <button class="solicitare-card__upload-file-delete" type="button" matTooltip="Șterge fișierul încărcat" (click)="removeFileNota(i)">
                                                <img class="btn-img" src="../../../assets/icons/delete.svg" alt="" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px" *ngIf="uploading.file"></mat-spinner>

                                <input type="file" accept="image/png, image/jpeg, image/gif, image/jpg, application/pdf" id="upload-file-input-0" #fileInputNotita
                                    name="fileInputNotita" (change)="addFileNotita($event, 'file')" multiple style="display: none">

                            </div>
                            <div class="col d-flex justify-content-end">
                                <button [disabled]="!sendMessageNotitaForm.valid" class="btn btn-light upload-btn m-3" type="submit">
                                    <span class="upload__text">TRIMITE</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <app-cereri-istoric [user]="user" [istoric]="istoric" [id_cerere]="cerere?.id" [notifyIds]="cerere?.historyNotify ?? []"
            (requestInfoUpdated)="getRequestInfo()" (isLoading)="onIsLoadingChange($event)"></app-cereri-istoric>

    </div>
    <div class="col-4 ">
        <div class="g-0">
            <div class="col responsive-box-info">
                <div class="box-wrapper box-info">
                    <div class="box-content-header">
                        <div class="row p-1">
                            <div class="col">
                                <mat-card-title>
                                    <i class="fa-solid fa-circle-info"></i>
                                    <span>Info solicitare</span>
                                </mat-card-title>
                            </div>
                        </div>
                    </div>
                    <div class="box-content-body">
                        <table class="table table-condensed table-wrapper-box">
                            <tbody>
                                <tr>
                                    <td width="40%" class="text-center">
                                        <strong>Tip</strong>
                                    </td>
                                    <td class="text-left">{{cerere?.subject}}</td>
                                </tr>
                                <tr>
                                    <td width="40%" class="text-center">
                                        <strong>Categorie</strong>
                                    </td>
                                    <td class="text-left">{{cerere?.categorie_directie}}</td>
                                </tr>
                                <tr>
                                    <td width="40%" class="text-center">
                                        <strong>Email cetățean</strong>
                                    </td>
                                    <td class="text-left">{{cerereCetatean?.email || 'n/a'}}</td>
                                </tr>
                                <tr>
                                    <td width="40%" class="text-center">
                                        <strong>Categorie Departament</strong>
                                    </td>
                                    <td class="text-left">{{cerere?.categorie_compartiment}}</td>
                                </tr>
                                <tr>
                                    <td width="40%" class="text-center">
                                        <strong>Prioritate</strong>
                                    </td>
                                    <td class="text-left">
                                        <span class="badge" [ngStyle]="{
                                                'background-color': cerere?.priority_bg_color,
                                                color: '#ffffff'
                                              }">
                                            {{ cerere?.priority_name }}
                                        </span>
                                </tr>
                                <tr>
                                    <td width="40%" class="text-center">
                                        <strong>Status</strong>
                                    </td>
                                    <td class="text-left">
                                        <span class="badge" [ngStyle]="{
                                                'background-color': cerere?.status_bg_color,
                                                color: '#ffffff'
                                              }">
                                            {{ cerere?.status_name }}
                                        </span>
                                </tr>
                                <tr>
                                    <td width="40%" class="text-center">
                                        <strong>Sla</strong>
                                    </td>
                                    <td class="text-left">
                                        <div [innerHTML]="safeHtml"></div>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="40%" class="text-center">
                                        <strong>Institutie/Directie</strong>
                                    </td>
                                    <td class="text-left">{{ cerere?.directie?.name || 'n/a' }}</td>
                                </tr>
                                <tr>
                                    <td width="40%" class="text-center">
                                        <strong>Serviciu/Birou</strong>
                                    </td>
                                    <td class="text-left">{{ cerere?.compartiment?.name || 'n/a' }}</td>
                                </tr>
                                <tr>
                                    <td width="40%" class="text-center">
                                        <strong>Solicitare asignat</strong>
                                    </td>
                                    <td class="text-left" *ngIf="operator[0]">{{ operator[0].name }}</td>
                                    <td class="text-left" *ngIf="!operator[0]">{{ 'n/a' }}</td>
                                </tr>
                                <tr>
                                    <td width="40%" class="text-center">
                                        <strong>Dată creat</strong>
                                    </td>
                                    <td class="text-left">{{cerere?.created_at | date: 'dd.MM.yyyy HH:mm'}}</td>
                                </tr>
                                <tr>
                                    <td width="40%" class="text-center">
                                        <strong>Dată actualizat</strong>
                                    </td>
                                    <td class="text-left">{{cerere?.updated_at | date: 'dd.MM.yyyy HH:mm'}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="g-0" *ngIf="cerere?.type_slug !== 'suport_online_login' && cerere?.type_slug !== 'suport_online_account'"> -->
        <div class="g-0">
            <div class="col">
                <div class="box-wrapper box-actiuni-cerere responsive-box-info">
                    <div class="box-content-header">
                        <div class="row p-1">
                            <div class="col">
                                <mat-card-title>
                                    <i class="fa-solid fa-shuffle"></i>
                                    <span>Acțiuni Cerere</span>
                                </mat-card-title>
                            </div>
                        </div>
                    </div>
                    <div class="box-content-body">
                        <div class="row p-2 d-flex">
                            <div class="w-auto" *ngIf="
                                      cerere?.user_assigned_id == null ||
                                      cerere?.user_assigned_id !== user.id_user
                                    ">
                                <button class="btn btn-light upload-btn" type="button" (click)="confirmPreluarePersonala()">
                                    <span class="upload__text">PRELUARE PERSONALĂ</span>
                                </button>
                            </div>
                            <div class="w-auto" *ngIf="showPreluareNumarRegistratura()">
                                <button class="btn btn-light upload-btn" type="button" (click)="confirmPreluareNumarRegistratura()">
                                    <span class="upload__text">PRELUARE NUMĂR REGISTRATURA</span>
                                </button>
                            </div>
                        </div>
                        <div class="row p-2 d-flex box-content-body-responsive ">
                            <div class="col ">
                                <actiuni-cerere-card title="Status validat" description="Nevalidat" iconName="check" [cerere]="cerere" actionText="Validează"
                                    actionType="validate" (buttonClicked)="handleButtonClick($event)"
                                    (buttonResetClicked)="handleButtonResetClick($event)"></actiuni-cerere-card>
                            </div>
                            <ng-container>
                                <!-- *ngIf="cerere.cancel_type === null" -->
                                <div class="col" *ngIf="cerere?.validated_date === null">
                                    <actiuni-cerere-card title="Extra" description="Cerere incă valabilă de validare. Nu validați decât dacă este cazul!" iconName="report_problem"
                                        actionText="Invalidează" [cerere]="cerere" actionType="invalidate" (buttonClicked)="handleButtonClick($event)"
                                        (buttonResetClicked)="handleButtonResetClick($event)"></actiuni-cerere-card>
                                </div>
                                <div class="col" *ngIf="cerere?.validated_date !== null">
                                    <actiuni-cerere-card title="Clasare" description="Clasare" iconName="report_problem" actionText="Clasare" [cerere]="cerere"
                                        actionType="anulare" (buttonClicked)="handleButtonClick($event)"
                                        (buttonResetClicked)="handleButtonResetClick($event)"></actiuni-cerere-card>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="cerere?.cancel_type !== null || cerere?.validated_date !== null">
                                <div class="col">
                                    <actiuni-cerere-card title="Status Închidere Lucrare" description="Inchidere lucrare doar in momentul in care a fost solutionata cererea."
                                        iconName="check" actionText="Inchidere lucrare" [cerere]="cerere" actionType="finalizare"
                                        (buttonClicked)="handleButtonClick($event)"
                                        (buttonResetClicked)="handleButtonResetClick($event)"></actiuni-cerere-card>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <app-actualizare-cerere [data]="data" (cerereChanged)="onCerereChanged($event)" (istoricChanged)="onIstoricChanged($event)"></app-actualizare-cerere>
    </div>
</div>
<div class="section-spinner position-fixed" *ngIf="isLoading">
    <div class="spinner position-absolute top-50 start-50 translate-middle">
        <img src="assets/icons/logo-ps4-icon.svg" height="50%" width="50%" alt="PS4" />
        <mat-spinner></mat-spinner>
        <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
    </div>
</div>